import "../assets/index26.css";
import { jsx as c } from "react/jsx-runtime";
import { forwardRef as f } from "react";
import { c as l } from "./index.80e735c1.js";
import { m as u } from "./make-refs.cb0b9b76.js";
function p(s) {
  return !Number.isNaN(s) && !Number.isNaN(Number.parseFloat(s));
}
const d = "_img_8z8h7_1", g = "_mask_8z8h7_2", a = {
  img: d,
  mask: g,
  "size-16": "_size-16_8z8h7_25",
  "size-32": "_size-32_8z8h7_31"
}, h = "/shared_res/agility/next-components/assets/icons", N = 24, y = f(
  ({ className: s, icon: e, method: z = "mask", style: i, ...t }, _) => {
    const { $el: r } = u(_, ["$el"]), [m] = e.split("/"), o = p(m) ? Number(m) : N, n = `${h}/${e}.svg`;
    return z === "mask" ? /* @__PURE__ */ c(
      "span",
      {
        "aria-hidden": "true",
        className: l(a.mask, a[`size-${o}`], s),
        "data-icon": e,
        ref: r,
        style: {
          maskImage: `url(${n})`,
          ...i
        },
        ...t
      }
    ) : (
      // biome-ignore lint/a11y/useAltText: ok
      /* @__PURE__ */ c(
        "img",
        {
          alt: `Icon: ${e}`,
          "aria-hidden": "true",
          className: l(a.img, s),
          "data-icon": e,
          height: o,
          loading: "lazy",
          ref: r,
          src: n,
          style: i,
          ...t
        }
      )
    );
  }
);
export {
  y as I,
  p as i
};
//# sourceMappingURL=index.3a885b6a.js.map
